// extracted by mini-css-extract-plugin
export default {"title":"SettingsSearchServices_title__jX737","searchBar":"SettingsSearchServices_searchBar__0z5-k","dropdown":"SettingsSearchServices_dropdown__q4041"};